// extracted by mini-css-extract-plugin
module.exports = {"four04":"__404_four04__Lo9u2"};